"use client";

import { OnboardingItemLayout } from "@/components/Onboarding/components/OnboardingItemLayout";
import { Button } from "@/components/ui/button";
import {
  Action,
  ControlType,
  useOnboardingAnalytics,
} from "@/context/AnalyticsProvider";
import { useOnboardingStep } from "@/context/OnboardingStepProvider/OnboardingStepProvider";
import { ArrowRight } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { KeyAnimation } from "../components/KeyAnimation";
import { OnboardingStep, type OnboardingStepProps } from "../constants";

export const FreeEntryUnlockedInfo = ({ visible }: OnboardingStepProps) => {
  const referralCode = useSearchParams()?.get("ref")?.trim();
  const { isModal, closeModal, currentStep } = useOnboardingStep();
  const { track } = useOnboardingAnalytics();
  const hasViewedRef = useRef(false);
  const router = useRouter();

  useEffect(() => {
    if (hasViewedRef.current || !visible) return;
    hasViewedRef.current = true;

    track({
      action: Action.VIEWED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_UNLOCKED_INFO,
        step: currentStep,
      },
    });
  }, [track, visible, currentStep]);

  const handleButtonClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_UNLOCKED_INFO,
        step: currentStep,
        control: "next-step",
        controlType: ControlType.BUTTON,
      },
    });

    isModal
      ? closeModal()
      : // Redirect to /referral if user came with referral code, otherwise /quests
        router.push(referralCode ? "/referral" : "/quests");
  };

  const handleAnimationClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        id: OnboardingStep.FREE_ENTRY_UNLOCKED_INFO,
        step: currentStep,
        control: "key-animation",
        controlType: ControlType.IMAGE,
      },
    });
  };
  return (
    <OnboardingItemLayout>
      <div className="space-y-0 sm:space-y-3">
        <h1 className="font-bold text-[clamp(1.5rem,4.25dvh,1.875rem)] leading-[clamp(1.875rem,5dvh,2.25rem)] text-center">
          <span className="imx-gradient text-sm font-bold leading-5 tracking-[2px] uppercase text-center">
            NICE WORK!
          </span>{" "}
          <br />
          You've unlocked
          <br />
          1x FREE entry
        </h1>
        <span className="text-white py-1 text-base font-normal leading-6 text-center block">
          Your rewards key tier is <strong>Common</strong>.
        </span>
        <KeyAnimation handleAnimationClick={handleAnimationClick} />
        <span className="text-white text-base font-normal leading-6 text-center block">
          Better key = Better chance
        </span>
      </div>
      <div className="flex flex-col items-center gap-2 w-full">
        <Button
          size="lg"
          className="w-full rounded-full py-4 text-base font-semibold relative"
          onClick={handleButtonClick}
        >
          Level up your key
          <ArrowRight className="absolute size-5 right-4" strokeWidth={3.5} />
        </Button>
      </div>
    </OnboardingItemLayout>
  );
};
